export default "__VITE_ASSET__e9f1be86__"